<p>entity-state-count works!</p>
